export const normalizeWsUrl = (url: string): string =>
  url.endsWith("/") ? url : `${url}/`;
